const getChosenAccessories = (accessories, chosenAccessories) => {
  return accessories.filter(item => chosenAccessories.includes(item.id))
}

export default getChosenAccessories
